import { request, setDefaultRequestOptions } from '@esri/arcgis-rest-request';
import FormData from 'isomorphic-form-data';
import fetch from 'isomorphic-unfetch';

const createRequestClient = () => {
  // @ts-ignore
  setDefaultRequestOptions({ fetch, FormData });
  return request;
};

export { createRequestClient };
